import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { useEvent } from '../context/EventContext';
import { ImagePlaceholder } from '../components/ImagePlaceholder';
import { loc, locSections } from '../lib/i18nContent';

const isEditorial = (p) => ['EDITORIAL', 'VALIDATION', 'ВАЛИДАЦ', 'ТРЕБ', 'NEPIECIE', 'REDAKC'].some((x) => p.toUpperCase().startsWith(x));

export default function VisitReims() {
  const { t, lang } = useLang();
  const { config } = useEvent();
  const reims = config?.reims;
  const settings = config?.settings || {};
  const ctaUrl = settings.reims_cta_url;
  const ctaLabel = t('reims_default_cta');

  if (!reims) return null;
  const sections = locSections(reims, lang);

  return (
    <div data-testid="reims-screen">
      {reims.image_url ? (
        <div className="rounded-xl overflow-hidden border border-[#D4AF37]/25 bg-[#FDFBF7]" data-testid="reims-portrait">
          <img src={reims.image_url} alt={loc(reims, lang, 'title')} className="w-full h-auto object-contain" />
        </div>
      ) : reims.video_url ? (
        <video
          src={reims.video_url}
          controls
          playsInline
          preload="metadata"
          data-testid="reims-video"
          className="w-full aspect-video rounded-xl border border-[#D4AF37]/25 bg-black"
        />
      ) : (
        <ImagePlaceholder ratio="aspect-[16/10]" label="Reims image — supplied later" />
      )}

      <h1 className="font-serif font-bold text-3xl text-[#FDFBF7] mt-4 leading-tight">{loc(reims, lang, 'title')}</h1>
      <p className="font-sans text-[15px] text-slate-300 mt-2 leading-relaxed">{loc(reims, lang, 'intro')}</p>

      <div className="mt-5 space-y-4">
        {sections.map((s, i) => (
          <div key={i} className="bg-[#111A38] border border-[#D4AF37]/20 rounded-xl p-4">
            <h3 className="font-serif text-xl text-[#E5C158]">{s.title}</h3>
            {s.body.split('\n\n').map((para, j) => (
              <p key={j} className={`mt-1 leading-relaxed ${isEditorial(para) ? 'text-slate-500 italic text-xs' : 'text-slate-200 text-sm'}`}>{para}</p>
            ))}
          </div>
        ))}
      </div>

      {ctaUrl ? (
        <a
          href={ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reims-cta"
          className="mt-6 w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#D4AF37] to-[#E5C158] text-[#070C1E] font-bold py-4 rounded-xl active:scale-[0.98] transition-all"
        >
          {ctaLabel} <ExternalLink size={16} />
        </a>
      ) : (
        <div
          data-testid="reims-cta-disabled"
          className="mt-6 w-full flex items-center justify-center gap-2 border border-[#D4AF37]/30 text-slate-500 font-semibold py-4 rounded-xl cursor-not-allowed"
        >
          {ctaLabel}
        </div>
      )}
    </div>
  );
}
